<script>
    import Vue from 'vue';

    export default {
        functional: true,

        props: {
            fromRight: {type: Boolean, default: false},
            fullWidth: {type: Boolean, default: false},
            onTop: {type: [Boolean, Number, String], default: false},
        },

        render(createElement, context) {
            let {fromRight, fullWidth} = context.props;
            let position = 'fixed';
            let translateX = -Vue.$ui.scrollLeft;
            let top = null;
            let width;

            if (fromRight) {
                translateX = Vue.$ui.scrollWidth - Vue.$ui.clientWidth - Vue.$ui.scrollLeft;
            }
            if (fullWidth) {
                width = Vue.$ui.scrollWidth + 'px';
            }

            return createElement('div', {
                class: 'sticky',
                style: {
                    position,
                    transform: `translateX(${translateX}px)`,
                    width,
                    top,
                },
                on: context.listeners,
                ...context.data,
            }, context.children);
        },
    };
</script>
